import React from 'react';
import {Helmet} from "react-helmet";
import { Box, Container} from '@mui/material';
//import logo from '../../assets/images/logo_new.png';
//import arrow_down from "../../assets/images/arrow-down-01.png"
import red from "./assets/images/rent-shield-logo.svg";
//import redalert from "../../assets/images/redhover.png";
//import rend_id2 from "../../assets/images/rend_id2.png";
//import { Link } from 'react-router-dom';
//import { useLocation, useNavigate } from 'react-router-dom';
import RentShieldAnimation from './RentshieldAnimation';
import AIheader from '../../pages/RentAI/AIheader';
import RentShieldPage from './RentShieldPage/RentShieldPage';

import DigitalClaims from './DigitalClaims/DigitalClaims';
import ProtectionSettings from './ProtectionSettings/ProtectionSettings';
import InsuranceServicesFaq from './InsuranceServicesFaq/InsuranceServicesFaq';
import RentShieldInsurance from './RentShieldInsurance/RentShieldInsurance';
import MoreSolutionsShield from './MoreSolutionsShield/MoreSolutionsShield';
// import PopularTopics from '../Rentid2/PopularTopics/PopularTopics';
import RentHeader from '../RentHeader/RentHeader';
import BetaForm from '../BetaForm';
import Footer from '../Footer/Footer';

const RentShield2 = () => {

  //const navigate = useNavigate();

//const location = useLocation();
//console.log(location.pathname);

  return (
    <>
      <Helmet>
        <title>RentShield | Commercial Auto Insurance & Protection for Rental Fleets</title>
        <meta name="description" content="Protect your rental fleet with RentShield’s dynamic on-rent coverage and protection plans. Offering flexible, A-rated insurance solutions, guest protection plans, 24/7 roadside assistance, and digital claims management for seamless rental operations." />
        <link rel="canonical" href="https://www.rentid.io/rentshield" />
        <meta name="keywords" content="Commercial Auto Insurance, Rental Fleet Insurance, Guest Protection Plans, National Roadside Assistance, Digital Claims Management, On-Demand Coverages, Vehicle Protection, Rentid Insurance Solutions, Fleet Compliance, Automated Insurance" />
        <meta property="og:url" content="https://www.rentid.io/rentshield" />
        <meta property="og:title" content="RentShield | Commercial Auto Insurance & Protection"></meta>
        <meta property="og:description" content="entShield offers dynamic on-rent coverage for rental fleets, including commercial auto insurance, guest protection plans, roadside assistance, and digital claims management. Keep your rental business compliant and protected." />
        <meta name="twitter:title" content="RentShield | Commercial Auto Insurance & Protection" />
        <meta name="twitter:description" content="Discover RentShield's flexible and comprehensive insurance solutions for rental fleets. From A-rated commercial auto insurance to 24/7 roadside assistance, we’ve got your rental business covered." />
      </Helmet>
      <Box
        sx={{
          background: 'linear-gradient(180deg, #082C72 0%, #001132 55%, #000000 100%)',
          height: '100vh',
          display: 'none',
          width: '100%',
        }}
      >
        <Container>

          <RentHeader />


          {/* Banner section start from here */}

          <section className='bannerShieldIdMain'>
            <div className="row">
              <div className='col-lg-5'>
                <div className='bannerShieldLeft'>
                  <img src={red} alt="" />
                  <small>EMBEDDED INSURANCE AND PROTECTION PLANS</small>
                  <h1 className='desktopShieldHead'><span>Coverage, protection</span> & peace of mind for revenue generating assets</h1>
                  <h1 className='mobileShieldHead'>
                    <span>Coverage,</span> <span>protection</span> & peace of mind for revenue generating assets
                  </h1>
                  <p>Rent your fleet confidently while maintaining compliance, legality, and sustainable growth.</p>
                </div>
              </div>

              <div className='col-lg-7'>
                <div className='bannerShieldRight'>
                  {/* <img src={redalert} alt=''/> */}
                  <RentShieldAnimation />
                </div>
              </div>
            </div>
          </section>

        </Container>
      </Box>

    
    
      <>
        <AIheader />
        <div className="rd-legacy">
          <RentShieldPage />
          <DigitalClaims />
          <ProtectionSettings />
          <InsuranceServicesFaq />
          <RentShieldInsurance />
          <MoreSolutionsShield />
          {/* <PopularTopics/>  */}
        </div>
        <Footer />
      </>

      <BetaForm />
    </>
      
  )
}

export default RentShield2;
